import { Component, OnInit, Input, OnChanges, SimpleChanges, Output, EventEmitter } from '@angular/core';
import { PagingModel } from '../../models/input/paging-model';
import { LinkClickSateType } from '../../enum/link-click-state-type';

@Component({
  selector: '.ui-paging',
  templateUrl: './paging.component.html',
  styleUrls: ['./paging.component.css'],
  standalone: false
})
export class PagingComponent implements OnInit, OnChanges {

  @Input() pagingInput!: PagingModel;
  @Output() eventOnClickPrevLink = new EventEmitter<LinkClickSateType>();
  @Output() eventOnClickNextLink = new EventEmitter<LinkClickSateType>();

  paging: PagingModel | null = null;



  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['pagingInput'] && changes['pagingInput'].currentValue) {
      this.pagingMapping();
    }
  }

  pagingMapping(): void {
    const pagingInput = this.pagingInput;
    pagingInput.hasPrevLink = pagingInput.checkHasPrevLink();
    pagingInput.hasNextLink = pagingInput.checkHasNextLink();
    this.paging = pagingInput;
  }

  onClickPrevLink() {
    if (this.paging?.hasPrevLink) {
      this.eventOnClickPrevLink.emit(LinkClickSateType.ALLOWED);
    } else {
      this.eventOnClickPrevLink.emit(LinkClickSateType.IMPOSSIBLE);
    }
  }

  onClickNextLink() {
    if (this.paging?.hasNextLink) {
      this.eventOnClickNextLink.emit(LinkClickSateType.ALLOWED);
    } else {
      this.eventOnClickNextLink.emit(LinkClickSateType.IMPOSSIBLE);
    }
  }

}
